import fonts from '../theme/foundations/fonts'

const baseStyle = {}

const defaultProps = {
  size: 'md',
}

const sizes = {
  xs: {
    fontSize: 'xs',
    lineHeight: '18px',
    marginBottom: '6px',
  },
  sm: {
    fontSize: 'sm',
    lineHeight: '22px',
    marginBottom: '7px',
  },
  md: {
    fontSize: 'md',
    lineHeight: '26px',
    marginBottom: '8px',
  },
  lg: {
    fontSize: 'lg',
    lineHeight: '32px',
    marginBottom: '9px',
  },
}

const variants = {
  mono: {
    fontFamily: fonts.mono,
  },
}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
